import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  selectCurrentEmail,
  selectCurrentPatientGroup,
  selectCurrentToken,
  useCurrentTermsOfUseAcceptance,
} from "../features/auth/authSlice";

import { useSelector } from "react-redux";

const RequireAuth = () => {
  const termsOfUsePage = "/termsOfUse";
  const isLoggedIn = !!useSelector(selectCurrentToken);
  const userEmail = useSelector(selectCurrentEmail);
  const patientGroup = useSelector(selectCurrentPatientGroup);
  const termsOfUseAccepted = useCurrentTermsOfUseAcceptance();
  const location = useLocation();
  return isLoggedIn && !!patientGroup?.[userEmail] ? (
    !termsOfUseAccepted && location.pathname !== termsOfUsePage ? (
      <Navigate to={termsOfUsePage} state={{ from: location }} replace />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
